import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import store from '../../store'
import { observer } from 'mobx-preact';

@observer class ServicesHeader extends Component {

	componentDidMount(){
       if(this.props.header&&this.props.header.particles){
         this.addParticles();
       }
	}

  addParticles(){
     if (typeof window !== "undefined"&&this.particlesRef) {
           import('../../components/particles').then((res)=>{
             this.pJS = new res(this.particlesRef, {});
           })
         }
  }

  componentDidUpdate(prevProps){
    if(prevProps.header!=this.props.header){
      this.addParticles()
    }
  }

	componentWillUnmount() {
		if (this.pJS && this.pJS.pJS) this.pJS.pJS.fn.vendors.destroypJS();
		this.pJS = null;
	}

	render() {
    let profile = this.props.header&&this.props.header.profile?"profile-header ":"";
    let particles = this.props.header&&this.props.header.particles?"header_with_particles ":"";
    let img = this.props.header&&this.props.header.img?"header_with_img ":"";
    let extended = this.props.header&&this.props.header.extended?"extended ":"";
    let clipped = this.props.header&&this.props.header.clipped?(this.props.header.clipped==2?"custom_header_with_clippath2 ":"custom_header_with_clippath "):"";
    let result = profile+particles+img+extended
		return (
         this.props.header&&
           <div id="page-header" class={`${result}`} style={{backgroundImage: this.props.header?'url(/assets/img/page-header/'+this.props.header.img+')':null}} >
             <div class="container wide">
               {this.props.header&&this.props.header.particles&&
                 <canvas style="width:100%;height:100%;position:absolute;top:0;left:0;" ref={(el)=>this.particlesRef = el} ></canvas>
               }
               <h1 key={store.lang} class={clipped}><Text id={this.props.header?this.props.header.title:""}/> <Text id={this.props.header&&this.props.header.title2?this.props.header.title2:""}/></h1>
             </div>
           </div>
         
    );
	}
}

export default ServicesHeader



// WEBPACK FOOTER //
// ./components/header/servicesHeader.js